import React, { useEffect, useState } from "react";
import { FormCheckbox, FormTextInput } from "components/form-fields";
import { ListingTable } from "components/listing";
import { Filter, FilterButton } from "components/filtering";
import { UserService } from "services";
import { NotificationToaster } from "components/notifications";
import { Intent } from "@blueprintjs/core";
import PropTypes from "prop-types";

export function LicenceCheckingUserSearch({
    isOpen = false,
    selectedUserId = "",
    handleCheckboxChange = () => {}
}) {
    const pageFilters = [
        {
            name: "Role",
            items: [
                { id: "AdvancedEditor", name: "Advanced Editor" },
                { id: "CompanyAdmin", name: "Company Admin" },
                { id: "Editor", name: "Editor" },
                { id: "AccountOwner", name: "Primary Contact" },
                { id: "Viewer", name: "Viewer" },
            ],
        },
    ];
    const pageSize = 25;
    const [searchTerm, setSearchTerm] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [tableRows, setTableRows] = useState([]);
    const [tableRowsCount, setTableRowsCount] = useState(0);
    const [licenceCheckingUsersData, setLicenceCheckingUsersData] = useState(
        []
    );
    const [showFilters, setShowFilters] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (isOpen) {
            getLicenceCheckingUsers();
        }
    }, [isOpen, pageNumber, searchTerm, appliedFilters]);

    useEffect(() => {
        setTableRows(
            licenceCheckingUsersData.map((user) => {
                return [
                    user.emailAddress,
                    `${user.firstName} ${user.lastName}`,
                    user.role.name,
                    <div
                        key={`${user.userId}-selected`}
                        className="text-align-center"
                    >
                        <FormCheckbox
                            checked={user.userId === selectedUserId}
                            identifier={user.userId}
                            onChange={(event, userId) =>
                                handleCheckboxChange(event, userId)
                            }
                        />
                    </div>
                ];
            })
        );
    }, [licenceCheckingUsersData, selectedUserId]);

    function getLicenceCheckingUsers() {
        UserService.getUserListWebsite(
            pageSize,
            pageNumber,
            searchTerm,
            "",
            "",
            [
                ...appliedFilters,
                {
                    name: "EXCLUDELICENCECHECKING",
                    value: true
                }
            ]
        )
            .then(
                (result) => {
                    setLicenceCheckingUsersData(result.data);
                    setTableRowsCount(result.totalCount);
                },
                () => {
                    NotificationToaster.show(
                        Intent.DANGER,
                        "Error loading users"
                    );
                }
            )
            .catch(() => {
                NotificationToaster.show(Intent.DANGER, "Error loading users");
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    function onToggleFilter() {
        setShowFilters((prevState) => {
            return !prevState;
        });
    }

    function onFilterChange(listingFilters) {
        setAppliedFilters(listingFilters);
    }

    return (
        <div>
            <div className="spacer-bottom">
                <div className="filter-controls">
                    <div className="inline-items inline-items-fill">
                        <div className="inline-item">
                            <FormTextInput
                                id="user-search-field"
                                icon="search"
                                placeholder="Search users"
                                onChange={(x) => setSearchTerm(x.target.value)}
                                value={searchTerm}
                                large
                                fill
                            />
                        </div>
                        <FilterButton onToggle={onToggleFilter} filters={appliedFilters} />
                    </div>   
                    <Filter
                        filterName="scheduleWizard"
                        visible={showFilters}
                        filters={pageFilters}
                        onUpdate={onFilterChange}
                        onClickOutside={onToggleFilter}
                    />
                </div>  
            </div>
            <h3>All Users</h3>
            <ListingTable
                id="licence-checking-add-user-listing"
                loadingData={isLoading}
                headers={["email address", "name", "role", "selected"]}
                data={tableRows}
                totalRecordCount={tableRowsCount}
                pageSize={pageSize}
                pageable={true}
                onPagingChange={(page) => setPageNumber(page)}
                sortable={false}
                showPerPage={false}
                fixedHeight
            />
        </div>
    );
}

LicenceCheckingUserSearch.propTypes = {
    isOpen: PropTypes.bool,
    selectedUserId: PropTypes.number,
    handleCheckboxChange: PropTypes.func,
};
